"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvalidRequestError = void 0;
const is_error_1 = require("./is-error");
const error_codes_1 = require("../lib/error-codes");
const args_1 = require("../lib/args");
/**
 * When a user initiates an invalid request. Use when showing a specific error message to the user that is useful, this message
 * should be able to inform the user of something they did wrong so they can correct it on the next request.
 *
 * If the error is not the user's fault, or showing a "Something went wrong" message to the user seems appropriate, consider using
 * InvalidStateError or RequestFailedError.
 */
class InvalidRequestError extends is_error_1.IsError {
    issues;
    constructor(messageOrError, errorOrArgs, args) {
        const { message, originalError, errorArgs } = (0, args_1.readErrorArgs)(messageOrError, errorOrArgs, args);
        super(error_codes_1.StatusErrorCode.INVALID_REQUEST, InvalidRequestError.name, message, errorArgs?.reasonCode || error_codes_1.ErrorGenericReasonCode.USER_INPUT_ERROR, errorArgs?.userMessage || error_codes_1.ErrorMessage.SOMETHING_WENT_WRONG, originalError, errorArgs);
        this.issues = errorArgs?.issues || {};
    }
}
exports.InvalidRequestError = InvalidRequestError;
